import { Navigate } from "react-router-dom";
import { useAuthState } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuthState();

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
